import { render, staticRenderFns } from "./IncoAssessment.vue?vue&type=template&id=16417d14&"
import script from "./IncoAssessment.vue?vue&type=script&lang=js&"
export * from "./IncoAssessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports